import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title-cell',
  templateUrl: './title-cell.component.html',
  styleUrl: './title-cell.component.scss'
})
export class TitleCellComponent {
  @Input() text : string
  @Input() upperCase? : boolean = false
  constructor(){

  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

  }
}
